import ActionsForStringId from '../../odata/actionsForStringId';

const actions = new ActionsForStringId('productGroup', 'productGroups', 'code');

export default actions;
